import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { CHECKOUT_URL } from '../data/content';
import { Countdown } from './Countdown';
interface CtaBlockProps {
  label: string;
  note?: string;
  showTimer?: boolean;
  id?: string;
  className?: string;
}
export function CtaBlock({
  label,
  note,
  showTimer = true,
  id,
  className = ''
}: CtaBlockProps) {
  return <div id={id} className={`flex flex-col items-center text-center ${className}`} data-id="element-76" data-mp="1zq2p7ky8ta25">
      <a href={CHECKOUT_URL} className="group flex w-full max-w-md items-center justify-center gap-2 rounded-xl bg-brand px-5 py-4 text-center font-display text-base uppercase leading-tight tracking-wide text-ink-950 shadow-[0_10px_30px_-12px_rgba(255,194,14,0.8)] transition-[transform,background-color] duration-150 ease-out hover:bg-brand-400 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-brand active:scale-[0.98] sm:text-lg" data-id="element-77" data-mp="1znzmq1fwlogj">
        <span data-id="element-78" data-mp="j9holoau5aiq">{label}</span>
        <ArrowRightIcon className="h-5 w-5 shrink-0 transition-transform duration-150 ease-out group-hover:translate-x-1" aria-hidden="true" data-id="element-79" data-mp="102xl71u9ua6q" />
      </a>
      {showTimer && <Countdown className="mt-4" data-id="element-80" data-mp="194nao24lez1v" />}
      {note && <p className="mt-3 max-w-md text-xs text-white/55" data-id="element-81" data-mp="195oxt4yvvbzy">{note}</p>}
    </div>;
}